import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useUserContext } from '../contexts/UserContext';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const isHomePage = location.pathname === '/' || location.pathname === '';
  const {
    user, _logout
   } = useUserContext();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavClick = (sectionId: string) => {
    if (isHomePage) {
      scrollToSection(sectionId);
    } else {
      // With HashRouter, navigate to home and pass state to scroll after route change
      navigate('/', { state: { scrollTo: sectionId } });
    }
    setIsOpen(false);
  };

  return (
    <nav className="bg-white dark:bg-slate-800 shadow-sm fixed top-0 left-0 right-0 z-50">
      <div className="w-full px-4">
        {/* Use justify-between to space logo left and links right */}
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="text-sm font-bold text-slate-900 dark:text-slate-50">
              <img
                src={theme === 'dark' ? 'logo-white.png' : 'logo.png'}
                alt="Logo"
                className="h-8 w-8 mr-2 inline-block"
              />
           {process.env.REACT_APP_DISPLAYNAME}
            </Link>
          </div>
          {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="flex items-center space-x-4">
              {user?.user_uuid ? 
            <Link
                    to="/dashboard"
                    className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Dashboard
                  </Link> : null }
            {!user?.user_uuid ? 
              <button
                onClick={() => handleNavClick('signals')}
                className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 px-3 py-2 rounded-md text-sm font-medium"
              >
                Signals
              </button> : null }
              <button
                onClick={() => handleNavClick('performance')}
                className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 px-3 py-2 rounded-md text-sm font-medium"
              >
                Performance
              </button>
              <button
                onClick={() => handleNavClick('features')}
                className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 px-3 py-2 rounded-md text-sm font-medium"
              >
                Features
              </button>
              <button
                onClick={() => handleNavClick('pricing')}
                className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 px-3 py-2 rounded-md text-sm font-medium"
              >
                Pricing
              </button>
              <Link
                to="/delistings"
                className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 px-3 py-2 rounded-md text-sm font-medium"
              >
                Delistings
              </Link>
              {!user?.user_uuid ? (
                <>
                  <Link
                    to="/login"
                    //className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 px-3 py-2 rounded-md text-sm font-medium"
                    className="px-3 py-2 rounded-md text-sm font-medium hover:bg-primary-dark"
                 >
                    Login
                  </Link>
                  <Link
                    to="/register"
                    className="px-3 py-2 rounded-md text-sm font-medium hover:bg-primary-dark"
                  >
                    Register
                  </Link>
                </>
              ) : (
          //       <>
                 
          //         <button
          // onClick={async ()=>{
          //             const result = await _logout()
          //             if(result==1){
          //               navigate('/login');
          //             }
          //           }}
          //           className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-md text-sm font-medium"
          //         >
          //           Logout
          //         </button>
          //       </>
          null
              )}
              {/* <button
                onClick={toggleTheme}
                className="px-3 py-2 rounded-md text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 focus:outline-none"
                aria-label="Toggle theme"
              >
                {theme === 'dark' ? (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                    />
                  </svg>
                ) : (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                    />
                  </svg>
                )}
              </button> */}
            </div>
          </div>
          {/* Mobile Menu */}
          <div className="flex items-center space-x-4 md:hidden">
            {/* <button
              onClick={toggleTheme}
              className="p-2 rounded-md text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 focus:outline-none"
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              ) : (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                  />
                </svg>
              )}
            </button> */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {!isOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`${isOpen ? 'block' : 'hidden'} md:hidden`} id="mobile-menu">
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <button
            onClick={() => handleNavClick('signals')}
            className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            Signals
          </button>
          <button
            onClick={() => handleNavClick('performance')}
            className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            Performance
          </button>
          <button
            onClick={() => handleNavClick('features')}
            className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            Features
          </button>
          <button
            onClick={() => handleNavClick('pricing')}
            className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 block px-3 py-2 rounded-md text-base font-medium w-full text-left"
          >
            Pricing
          </button>
          <Link
            to="/delistings"
            className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 block px-3 py-2 rounded-md text-base font-medium"
            onClick={() => setIsOpen(false)}
          >
            Delistings
          </Link>
          {!user?.user_uuid ? (
            <>
              <Link
                onClick={() => setIsOpen(false)}
                to="/login"
                className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 block px-3 py-2 rounded-md text-base font-medium"
              >
                Login
              </Link>
              <Link
                onClick={() => setIsOpen(false)}
                to="/register"
                className="bg-primary-main text-white block px-3 py-2 rounded-md text-base font-medium hover:bg-primary-dark"
              >
                Register
              </Link>
            </>
          ) : (
            <>
              {/* <Link
                onClick={() => setIsOpen(false)}
                to="/dashboard"
                className="text-slate-700 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-50 block px-3 py-2 rounded-md text-base font-medium"
              >
                Dashboard
              </Link> */}
              {/* <button
                onClick={async () => {
                  setIsOpen(false);
                  const result = await _logout();
                  // if(result==1) {
                  //   navigate('/login');
                  // }
                }}
                className="bg-red-500 hover:bg-red-600 text-white block w-full text-left px-3 py-2 rounded-md text-base font-medium"
              >
                Logout
              </button> */}
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
